import { queryOptions, useQuery } from "@tanstack/react-query";
import type { PriceString } from "./types";
import { api } from "@/lib/http";

export type TokenPacket = {
  id: string;
  price: PriceString;
  token_amount: number;
  description: string;
};

async function getTokenPackets() {
  return await api.payment.get<Array<TokenPacket>>("v1/token-packets/");
}

async function getTokenPacketDetail(id: string) {
  return await api.payment.get<TokenPacket>(`v1/token-packets/${id}`);
}

export const tokenPacketsQueryOptions = queryOptions({
  queryKey: ["payment", "token-packets"],
  async queryFn({ client }) {
    const res = await getTokenPackets();
    const data = await res.json();
    data.map((packet) =>
      client.setQueryData(
        tokenPacketDetailQueryOptions(packet.id).queryKey,
        packet,
      ),
    );
    return data;
  },
});

// made it a named function to hoist
export function tokenPacketDetailQueryOptions(id: string) {
  return queryOptions({
    queryKey: [...tokenPacketsQueryOptions.queryKey, id],
    async queryFn() {
      const res = await getTokenPacketDetail(id);
      return await res.json();
    },
  });
}

export function useTokenPackets() {
  return useQuery(tokenPacketsQueryOptions);
}

export function useTokenPacketDetail(id: string) {
  return useQuery(tokenPacketDetailQueryOptions(id));
}
